export const roofTileOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: 'ほとんど無被害' },
  { value: '2', text: '著しいずれ' },
  { value: '3', text: '全面的にずれ、破損' }
]

export const windowOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: 'ほとんど無被害' },
  { value: '2', text: '歪み、ひび割れ' },
  { value: '3', text: '落下の危険あり' }
]

export const exteriorWetMaterialOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: 'ほとんど無被害' },
  { value: '2', text: '部分的なひび割れ、隙間' },
  { value: '3', text: '顕著なひび割れ、剥離' }
]

export const exteriorDryMaterialOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: '目地の亀裂程度' },
  { value: '2', text: '板に隙間が見られる' },
  { value: '3', text: '顕著な目地ずれ、板破壊' }
]

export const signboardOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: '傾斜無し' },
  { value: '2', text: 'わずかな傾斜' },
  { value: '3', text: '落下の危険あり' }
]

export const outdoorStairsOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: '傾斜無し' },
  { value: '2', text: 'わずかな傾斜' },
  { value: '3', text: '明確な傾斜' }
]

export const otherItemOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: '安全' },
  { value: '2', text: '要注意' },
  { value: '3', text: '危険' }
]

export const roofMaterialOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: 'ほとんど無被害' },
  { value: '2', text: '著しいずれ' },
  { value: '3', text: '全面的にずれ、破損' }
]
